"use strict";
require('es6-promise').polyfill()

import ajaxInterceptor from './ajax-http-interceptor'
import Vue from 'vue'
import VueCookie from 'vue-cookie'

Vue.use(VueCookie)

Vue.mixin({
	data () {
		return {
			_ : _,
		}
	}
})

import Core from '@/vue/apps/core/core.vue'
export default new Vue({
	components: { Core: Core },
  })



// WEBPACK FOOTER //
// ./resources/mhg/js/core/core.js